import c from 'classnames';
import { RefObject } from 'react';

import { Icon } from '@repo/ui';

import styles from './TinyAIComposerInput.module.css';

interface TinyAIComposerInputProps {
  inputRef: RefObject<HTMLTextAreaElement>;
  value: string;
  onChange: (value: string) => void;
  onKeyDown: (e: React.KeyboardEvent<HTMLTextAreaElement>) => void;
  onSend: () => void;
  canSend: boolean;
}

export const TinyAIComposerInput = ({
  inputRef,
  value,
  onChange,
  onKeyDown,
  onSend,
  canSend,
}: TinyAIComposerInputProps) => {
  return (
    <div className={styles.inputContainer}>
      <textarea
        ref={inputRef}
        className={styles.input}
        value={value}
        onChange={e => onChange(e.target.value)}
        onKeyDown={onKeyDown}
        placeholder='Ask anything...'
        rows={1}
      />
      <button
        className={c(styles.sendButton, { [styles.active]: canSend })}
        onClick={onSend}
        disabled={!canSend}
        aria-label='Send message'
      >
        <Icon name='upSmall' size='s' />
      </button>
    </div>
  );
};
